import { render, staticRenderFns } from "./BidderSelectInputWidget.vue?vue&type=template&id=5ef6a1f0&scoped=true"
import script from "./BidderSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./BidderSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef6a1f0",
  null
  
)

export default component.exports